<template>
    <el-dialog
        title="Parsers"
        :visible.sync="showDialog"
        width="70%">
        <div>
            <div class="row">
                <div class="col-sm-12">
                    <table class="table table-striped table-hover">
                        <thead>
                        <tr>
                            <th>Parser</th>
                            <th style="width: 20%">Used by</th>
                            <th style="width: 50%">Notes</th>
                            <th>Example</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="parser in parsers">
                            <td><a href="#" @click.prevent="openConfig(parser.key)">{{ parser.name }}</a></td>
                            <td>{{ parser.employers }}</td>
                            <td v-html="parser.description" style="word-break: keep-all;"></td>
                            <td><a :href="url(`admin/settings/feeds/get-parser-example-file?parser_name=${parser.key}`)"
                                   target="_blank">Open</a></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="showDialog = false">Close</el-button>
            </span>

        <el-dialog
            :title="`Parser Config: ${configDialog.parserName}`"
            :visible.sync="configDialog.isVisible"
            width="50%"
            append-to-body>
            <div v-loading="configDialog.isLoading">
                <div class="form-group">
                    <textarea
                        v-model="configDialog.json"
                        class="form-control"
                        rows="18"
                        style="font-family: monospace; font-size: 13px; white-space: pre; overflow-x: auto;"
                    ></textarea>
                </div>
                <div v-if="configDialog.error" style="color: red; margin-top: 5px; font-weight: bold;">
                    {{ configDialog.error }}
                </div>
                <div v-if="configDialog.success" style="color: green; margin-top: 5px; font-weight: bold;">
                    Saved successfully.
                </div>
                <div style="margin-top: 10px;">
                    <el-button size="small" @click="formatJson">Format JSON</el-button>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="configDialog.isVisible = false">Cancel</el-button>
                <el-button type="primary" :loading="configDialog.isSaving" @click="saveConfig">Save</el-button>
            </span>
        </el-dialog>
    </el-dialog>
</template>

<script>
export default {
    props: [
        'isOpen',
    ],
    data() {
        return {
            parsers: [],
            configDialog: {
                isVisible: false,
                isLoading: false,
                isSaving: false,
                parserName: '',
                json: '',
                error: '',
                success: false,
            },
        };
    },
    mounted() {
        this.refresh();
    },
    computed: {
        showDialog: {
            get() { return this.isOpen; },
            set(val) { this.$emit('close'); }
        }
    },
    methods: {
        refresh() {
            return axios.get(url(`admin/settings/feeds/get-parser-list`))
                        .then(response => {
                            this.parsers = response.data;
                        });
        },
        openConfig(parserName) {
            this.configDialog.parserName = parserName;
            this.configDialog.isLoading = true;
            this.configDialog.isVisible = true;
            this.configDialog.json = '';
            this.configDialog.error = '';
            this.configDialog.success = false;

            axios.get(url(`admin/settings/feeds/parser-config/${parserName}`))
                .then(response => {
                    const raw = response.data.parser_config;
                    if (raw) {
                        try {
                            this.configDialog.json = JSON.stringify(JSON.parse(raw), null, 2);
                        } catch (e) {
                            this.configDialog.json = raw;
                        }
                    } else {
                        this.configDialog.json = '';
                    }
                })
                .catch(() => {
                    this.configDialog.error = 'Failed to load config.';
                })
                .finally(() => {
                    this.configDialog.isLoading = false;
                });
        },
        formatJson() {
            this.configDialog.error = '';
            if (!this.configDialog.json.trim()) return;

            try {
                const parsed = JSON.parse(this.configDialog.json);
                this.configDialog.json = JSON.stringify(parsed, null, 2);
            } catch (e) {
                this.configDialog.error = 'Invalid JSON: ' + e.message;
            }
        },
        saveConfig() {
            this.configDialog.error = '';
            this.configDialog.success = false;

            const raw = this.configDialog.json.trim();

            if (raw) {
                try {
                    JSON.parse(raw);
                } catch (e) {
                    this.configDialog.error = 'Invalid JSON: ' + e.message;
                    return;
                }
            }

            this.configDialog.isSaving = true;

            axios.post(url(`admin/settings/feeds/parser-config/${this.configDialog.parserName}`), {
                parser_config: raw || null,
            })
            .then(() => {
                this.configDialog.success = true;
            })
            .catch(error => {
                const msg = error.response && error.response.data && error.response.data.error;
                this.configDialog.error = msg || 'Failed to save config.';
            })
            .finally(() => {
                this.configDialog.isSaving = false;
            });
        },
    },
};
</script>

<style scoped>

</style>
